const { createAction } = require("../../helpers");
const {
  GET_CATEGORY,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_RESET,

  GET_CATEGORY_PRODUCTS,
  GET_CATEGORY_PRODUCTS_ERROR,
  GET_CATEGORY_PRODUCTS_SUCCESS,
  GET_CATEGORY_PRODUCTS_RESET,

  GET_SUB_CATEGORY,
  GET_SUB_CATEGORY_SUCCESS,
  GET_SUB_CATEGORY_ERROR,
  GET_SUB_CATEGORY_RESET,
} = require("./constants");

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */

const Categories = (storeType) => createAction(GET_CATEGORY, { storeType });

const CategoriesSuccess = (data) =>
  createAction(GET_CATEGORY_SUCCESS, { data });

const CategoriesError = (error) => createAction(GET_CATEGORY_ERROR, { error });

const CategoriesReset = () => createAction(GET_CATEGORY_RESET);

const CategoryProduct = ({ categoryName }) =>
  createAction(GET_CATEGORY_PRODUCTS, { categoryName });

const CategoryProductSuccess = (data) =>
  createAction(GET_CATEGORY_PRODUCTS_SUCCESS, { data });

const CategoryProductError = (error) =>
  createAction(GET_CATEGORY_PRODUCTS_ERROR, { error });

const CategoryProductReset = () => createAction(GET_CATEGORY_PRODUCTS_RESET);

const getSubCategories = (categoryName) => {
  console.log({ categoryName }, "dlkasjdljoi");
  return createAction(GET_SUB_CATEGORY, { categoryName });
};
const getSubCategoriesSuccess = (data) =>
  createAction(GET_SUB_CATEGORY_SUCCESS, { data });

const getSubCategoriesError = (error) =>
  createAction(GET_SUB_CATEGORY_ERROR, { error });

const getSubCategoriesReset = () => createAction(GET_SUB_CATEGORY_RESET);

module.exports = {
  Categories,
  CategoriesSuccess,
  CategoriesError,
  CategoriesReset,

  getSubCategories,
  getSubCategoriesSuccess,
  getSubCategoriesError,
  getSubCategoriesReset,

  CategoryProduct,
  CategoryProductSuccess,
  CategoryProductError,
  CategoryProductReset,
};
